import React, { useEffect, useState } from 'react';
import {
  Card,
  List,
  Avatar,
  Tag,
  Descriptions,
  Tabs,
  Space,
  Typography,
  Row,
  Col,
  Badge,
  Divider,
  Modal,
  Form,
  Input,
  Select,
  message,
  Popconfirm,
  Dropdown,
  Menu,
  Statistic,
  Empty,
  Button,
  DatePicker
} from 'antd';
import {
  UserOutlined,
  ArrowLeftOutlined,
  PhoneOutlined,
  MailOutlined,
  HomeOutlined,
  TeamOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
  CrownOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import InspectionBtn from '@/components/InspectionBtn';
import adminService from '@/services/admin.service';
import axios from 'axios';
import ownerService from '@/services/owner.service';
import toast from "react-hot-toast";
import dayjs from "dayjs";

const { Search } = Input;

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;



const OwnerShipManagement = () => {
  const [currentView, setCurrentView] = useState('owners');
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [owners, setOwners] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingOwner, setEditingOwner] = useState(null);
  const [form] = Form.useForm();
  const [ownerDetails, setOwnerDetails] = useState(null);
  const [subscriptionlist, setSubscriptionList] = useState([])
  const getStatusColor = (status) => {
    const colors = {
      'Active': 'green',
      'Maintenance': 'orange',
      'Transit': 'blue',
      'Loading': 'purple'
    };
    return colors[status] || 'default';
  };

  const getSubscriptionBadge = (subscription) => {
    if (subscription.status === 'Active' && subscription.isPaid) {
      return (
        <Badge
          count={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title={`${subscription.plan} - Active`}
        />
      );
    } else if (subscription.status === 'Expired' || !subscription.isPaid) {
      return (
        <Badge
          count={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
          title={`${subscription.plan} - ${subscription.status}`}
        />
      );
    }
    return null;
  };

  const getSubscriptionTag = (subscription) => {
 
    return (
      <Tag
        color={ 'gold' }
       >
        {subscription?.name}
      </Tag>
    );
  };

  const handleOwnerClick = async (owner) => {
    const ownerdetails = await adminService.getOwnerDetailById(owner.owner_id)
     setSelectedOwner(ownerdetails?.data.owner);
    setOwnerDetails(ownerdetails?.data);
    setCurrentView('detail');


  };

  const handleBackClick = () => {
    setCurrentView('owners');
    setSelectedOwner(null);
  };

  const handleAddOwner = () => {
    setEditingOwner(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEditOwner = (owner) => {
     setEditingOwner(owner);
    form.setFieldsValue({
      name: owner.owner_name,
      company_name: owner.company_name,
      username: owner.owner_name,
      email: owner.email,
      subscription: owner.subscription.name,
      expiry_date: dayjs(owner?.subscription.expiry_date)
    });
    setModalVisible(true);
  };

  const handleDeleteOwner = (ownerId) => {
    const updatedOwners = owners.filter(owner => owner.id !== ownerId);
    setOwners(updatedOwners);
    toast.success('Owner deleted successfully');

    if (selectedOwner && selectedOwner.id === ownerId) {
      handleBackClick();
    }
  };


  const getallowners = async () => {
    const ownerlist = await adminService.getallOwners();
     setOwners(ownerlist?.data)
  }
  useEffect(() => {
    getallowners()
  }, [])
   const handleModalSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (editingOwner) {
        // Update existing owner
        const payload = {
          email: values?.email,
          company_name: values?.company_name,
          subscription: values?.subscription,
          username: values?.username,
          expiry_date: values?.expiry_date

        }
         await ownerService.updateowner(editingOwner?.owner_id, payload)
        toast.success('Owner updated successfully');
      } else {
        // Add new owner
        const newOwner = {
          email: values?.email,
          password: values?.password,
          company_name: values?.company_name,
          subscription: values?.subscription,
          username: values?.username,
          expiry_date: values?.expiry_date

        };
        const { data } = await ownerService.createowner(
          newOwner);

        toast.success('Owner added successfully');
      }

      setModalVisible(false);
      form.resetFields();
      setEditingOwner(null);
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };

  // Owners List View
  const OwnersListView = () => (
    <div >
      <div className="flex items-center justify-between mb-4">
        {/* Left: Dashboard title */}
        <div className='flex gap-6'>
          <h1 className="text-lg font-bold">Dashboard</h1>

          {/* Middle: compact stats */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              <UserOutlined className="text-blue-500 text-sm" />
              <span className="text-xs text-gray-500">Users:</span>
              <Tag color="blue" className="text-xs px-2 py-0">
                {0}
              </Tag>
            </div>

            <div className="flex items-center gap-1">
              <span className="text-xs text-gray-500">Ships:</span>
              <Tag color="green" className="text-xs px-2 py-0">
                {0}
              </Tag>
            </div>
          </div>
        </div>

        <div className='flex gap-5'>
          <Search size='middle'
            className='!w-52'
            placeholder="Search  User"
            prefix={<SearchOutlined />}
            allowClear
          />        {/* Right: action button */}
          <InspectionBtn
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddOwner}
          >
            Add Owner
          </InspectionBtn>
        </div>
      </div>


      <Row gutter={[16, 16]}>
        {owners?.length ? owners.map(owner => (
          <Col xs={24} sm={4} lg={4} key={owner.owner_id}>
            <Card size='small'
              hoverable
              onClick={() => handleOwnerClick(owner)}
              className=" cursor-pointer transition-all duration-200  relative"
              extra={
                <div className="flex items-center space-x-2" onClick={e => e.stopPropagation()}>
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item
                          key="edit"
                          icon={<EditOutlined />}
                          onClick={() => handleEditOwner(owner)}
                        >
                          Edit
                        </Menu.Item>
                        <Menu.Item key="delete" icon={<DeleteOutlined />}>
                          <Popconfirm
                            title="Are you sure you want to delete this owner?"
                            onConfirm={() => handleDeleteOwner(owner.id)}
                            okText="Yes"
                            cancelText="No"
                          >
                            Delete
                          </Popconfirm>
                        </Menu.Item>
                      </Menu>
                    }
                    trigger={['click']}
                  >
                    <Button type="text" icon={<MoreOutlined />} size="small" />
                  </Dropdown>
                </div>
              }
            >
              <div className="text-center h-8">
                <div className='flex justify-center space-x-3'>
                  <Title level={4} className="mb-1 ms-2">{owner.owner_name}</Title>
                  <div className="mt-1">
                    {getSubscriptionTag(owner?.subscription)}
                  </div>
                </div>

              </div>


              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <Text className='font-12' strong>Ships:</Text>
                  <Badge count={owner.totalShips} showZero color="blue" />
                </div>
                <div className="flex justify-between items-center">
                  <Text className='font-12' strong>   Users:</Text>
                  <Badge count={owner.totalUsers} showZero color="green" />
                </div>
              </div>
            </Card>
          </Col>
        )) : <Typography.Text className=' font-12  text-gray-400 mx-auto mt-5'>No Owner found</Typography.Text>}
      </Row>
    </div>
  );

  // Owner Detail View
  const OwnerDetailView = () => {
    const ships = ownerDetails?.ships || [];
    const users = ownerDetails?.users || [];
    return (
      <div className="p-6">
        <div className="mb-6">
          <InspectionBtn
            icon={<ArrowLeftOutlined />}
            onClick={handleBackClick}
            className="mb-4"
          >
            Back to Owners
          </InspectionBtn>
          <Card className="mb-6">
            {selectedOwner ? <div className="flex items-start space-x-4">
              <div className="relative">
                <Avatar size={80} icon={<UserOutlined />} />
                {/* {getSubscriptionBadge(selectedOwner.subscription)} */}
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-3 mb-2">
                  <Title level={2} className="mb-0">{selectedOwner.owner_name}</Title>
                  {/* {getSubscriptionTag(selectedOwner.subscription)} */}
                </div>
                <Descriptions column={1} size="small">
                  <Descriptions.Item label={<><HomeOutlined className='me-3' /> Company</>}>
                    {selectedOwner.company_name}
                  </Descriptions.Item>
                  <Descriptions.Item label={"Created Date"}>
                    {selectedOwner.createdAt}
                  </Descriptions.Item>
                  <Descriptions.Item label={"Updated Date"}>
                    {selectedOwner.updatedAt}
                  </Descriptions.Item>
                </Descriptions>
              </div>
              <div className="text-right">
                <InspectionBtn
                  icon={<EditOutlined />}
                  onClick={() => handleEditOwner(selectedOwner)}
                  className="mb-4"
                >
                  Edit Owner
                </InspectionBtn>
                <div className="mb-2">
                  <Badge count={ships.length} showZero color="blue" />
                  <Text className="ml-2">Ships</Text>
                </div>
                <div>
                  <Badge count={users.length} showZero color="green" />
                  <Text className="ml-2">Users</Text>
                </div>
              </div>
            </div> : <Empty description="No Data found" />}

          </Card>
        </div>

        <Tabs defaultActiveKey="ships">
          <TabPane tab={`Ships (${ships.length})`} key="ships">
            <List
              grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 3 }}
              dataSource={ships}
              renderItem={(ship) => (
                <List.Item>
                  <Card
                    hoverable
                    title={
                      <div className="flex items-center justify-between">
                        <span>{ship.name}</span>
                        <Tag color={getStatusColor("Active")}>{ship.status}</Tag>
                      </div>
                    }
                    className="h-full"
                  >
                    <div className="space-y-2">
                      <div><Text strong className='me-3'>Type:</Text> {ship.vessel_type}</div>
                      <div><Text strong className='me-3'>Year of Build:</Text> {ship.year_of_build}</div>
                      <div><Text strong className='me-3'>Flag:</Text> {ship.flag}</div>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          </TabPane>

          <TabPane tab={`Users (${users.length})`} key="users">
            <List
              grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
              dataSource={users}
              renderItem={(user) => (
                <List.Item>
                  <Card size='small'
                    hoverable
                    title={
                      <div className="flex justify-between items-center">
                        <div>
                          <Avatar size={32} icon={<UserOutlined />} className="mr-3" />
                          <div>
                            <div className='ms-3'>{user.username}</div>
                            <div className='text-gray-500 ms-3'>  {user.email}</div>

                            <Text type="secondary" className="text-sm">{user.role}</Text>
                          </div>
                        </div>
                        <div>
                          <Text type="secondary" className="text-sm">{user.designation}</Text>

                        </div>
                      </div>
                    }
                    className="h-full"
                  >

                    <div>
                      <Text strong className="block mb-2">Ships Managed ({user.assignedShips.length}):</Text>
                      <div className="space-y-1">
                         {user?.assignedShips?.length ? user?.assignedShips?.map((shipName, index) => (
                          <Tag key={index} color="blue" className="mb-1">
                            <span>{shipName?.name}</span>
                            <span className='ms-1'>({shipName?.imo_number})</span>
                          </Tag>
                        )) : []}
                      </div>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  };

  const getAllSubscription = async () => {
    const sublist = await adminService.allsubscription();

    console.log("ASFasdf",sublist)
     setSubscriptionList(sublist?.data?.map(x => ({ label: x?.name, value: x?.name })))
  }
  useEffect(() => {
    getAllSubscription()
  }, [])
  return (
    <div className="min-h-screen px-4 bg-gray-50">
      {currentView === 'owners' ? <OwnersListView /> : <OwnerDetailView />}
      <Modal
        title={editingOwner ? 'Edit Owner' : 'Add New Owner'}
        open={modalVisible}
        onOk={handleModalSubmit}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
          setEditingOwner(null);
        }}
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            subscriptionPlan: 'Basic',
            subscriptionStatus: 'Active'
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Owner Name"
                name="name"
                rules={[{ required: true, message: 'Please enter owner name' }]}
              >
                <Input placeholder="Enter owner name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: 'Please enter email' },
                  { type: 'email', message: 'Please enter valid email' }
                ]}
              >
                <Input placeholder="Enter email" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="UserName"
                name="username"
                rules={[
                  { required: true, message: 'Please enter username' },
                ]}
              >
                <Input placeholder="Enter username" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Company Name"
                name="company_name"
                rules={[
                  { required: true, message: 'Please enter company name' },
                ]}
              >
                <Input placeholder="Enter company name" />
              </Form.Item>
            </Col>
            {!editingOwner && <Col span={12}>
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: 'Please enter Password' },
                ]}
              >
                <Input.Password placeholder="Enter Password" />
              </Form.Item>
            </Col>}

            <Col span={12}>
              <Form.Item
                label="Subscription Plan"
                name="subscription"
                rules={[{ required: true, message: 'Please select subscription plan' }]}
              >
                <Select placeholder="Select plan">
                  {subscriptionlist?.map(x => (
                    <Option value={x?.label}>
                      {x?.value}
                    </Option>

                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="Expiry Date"
                name="expiry_date"
                rules={[{ required: true, message: "Please select expiry date" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder="Select expiry date"
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>

          </Row>


        </Form>
      </Modal>
    </div>
  );
};

export default OwnerShipManagement;